import React, { memo } from 'react';
import classNames from 'classnames';

import { InputProps } from '../../helpers/AutoComplete';
import PrettyError from '../../decorators/PrettyError';
import DisplayError from '../../decorators/DisplayError';
import FormGroup from '../../helpers/FormGroup';
import BaseInput from '../../helpers/Input';
import BaseTextarea from '../../helpers/Textarea';
import { isResearcher } from '../../../utils/checkPermissions';
import { Card } from '../../helpers/Card';

import style from './style.module.css';

const Input = PrettyError(DisplayError(BaseInput));
const Textarea = PrettyError(DisplayError(BaseTextarea));

const CompanyTargetFixedPanelComponent = ({
  companyInfo,
  suggestResearcher,
  onChange,
  showInstruction,
  onClick,
  onDescriptionBlur,
  canEditData,
  user,
}) => {
  const hasAccess = () => {
    if (!user) return false;

    return !isResearcher(user.getIn(['roles', 0, 'slug'], null));
  };

  return (
    <Card as="form" className={classNames(style.host, 'row')}>
      <div className="col-xs-2">
        <FormGroup className={style.plainLabel}>
          <Input
            className="input-sm"
            disabled={!canEditData}
            label="Revenue"
            name="revenue"
            placeholder="Revenue"
            root={companyInfo}
            deep
            showLabel
          />
          <div className="clearfix" />
        </FormGroup>
        <FormGroup className={style.plainLabel}>
          <Input
            className="input-sm"
            disabled={!canEditData}
            label="Employees"
            name="employees"
            placeholder="Employees"
            root={companyInfo}
            deep
            showLabel
          />
          <div className="clearfix" />
        </FormGroup>
      </div>
      <div className="col-xs-5">
        <FormGroup>
          <Textarea
            className={style.description}
            disabled={!canEditData}
            label="Description"
            name="description"
            onBlur={onDescriptionBlur}
            placeholder="Description"
            root={companyInfo}
            rows="6"
            deep
            showLabel
          />
          <div className="clearfix" />
        </FormGroup>
        {showInstruction && (
          <p className="text-danger">
            Please make sure your description conforms to the appropriate format.
            <a href="#" onClick={onClick}>
              Click here
            </a>{' '}
            for further instructions.
          </p>
        )}
      </div>
      <div className="col-xs-5">
        <div className="row">
          <div className="col-xs-6">
            <label className="field-label">Last Researcher</label>
            <InputProps
              className="form-control input-sm"
              disabled={!canEditData || !hasAccess()}
              name="target.suggestDirector"
              placeholder="Last Researcher"
            >
              {suggestResearcher}
            </InputProps>
            <div className="clearfix" />
          </div>
          <div className="col-xs-6">
            <FormGroup>
              <Input
                className="input-sm"
                disabled={!canEditData || !hasAccess()}
                label="Last Researched"
                name="lastResearchedDate"
                onChange={onChange}
                placeholder="Last Researched Date"
                root={companyInfo}
                type="date"
                deep
                showLabel
              />
              <div className="clearfix" />
            </FormGroup>
          </div>
        </div>
        <div>
          <FormGroup>
            <Textarea
              className={style.notes}
              disabled={!canEditData}
              label="Research Notes"
              name="researchNotes"
              placeholder="Research Notes"
              root={companyInfo}
              rows="3"
              deep
              showLabel
            />
            <div className="clearfix" />
          </FormGroup>
        </div>
      </div>
    </Card>
  );
};

/** Company target fixed panel component. */
export const CompanyTargetFixedPanel = memo(CompanyTargetFixedPanelComponent);
